import { render } from "./GetHeroNavigation.vue?vue&type=template&id=b1476e3c&scoped=true"
import script from "./GetHeroNavigation.vue?vue&type=script&lang=js"
export * from "./GetHeroNavigation.vue?vue&type=script&lang=js"

import "./GetHeroNavigation.vue?vue&type=style&index=0&id=b1476e3c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1476e3c"],['__file',"src/scripts/view/portfolio/common/hero/GetHeroNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b1476e3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b1476e3c', __exports__)) {
    api.reload('b1476e3c', __exports__)
  }
  
  module.hot.accept("./GetHeroNavigation.vue?vue&type=template&id=b1476e3c&scoped=true", () => {
    api.rerender('b1476e3c', render)
  })

}


export default __exports__